import React from 'react'

export const Alpaka_Schnuppern = () => {
    return (
        <div className="randBox" id="schnuppern">
            <h2>Alpaka-Schnuppern am Sonntag</h2>
            <p>
            Jeden Sonntag laden wir euch herzlich auf die Alpakawiese oder je nach Wetterlage in den Stall ein. <br /> 
            Euch erwartet die Fütterung unserer Alpakas sowie spannende Informationen rund um diese faszinierenden Tiere. <br />
            Alle Fragen werden gerne beantwortet! Eigene Speisen und Getränke dürfen mitgebracht werden – <br />
            genießt euer Picknick in unserer gemütlichen Sitzecke mit Blick auf die Alpakawiese. <br />
            Kostenfreie Toiletten stehen auf dem Gelände zur Verfügung. 
            </p>
            <ul>
            <li><strong>Termine:</strong>
                <ul>
                    <li>Jeden Sonntag</li>
                    <li>Bitte telefonisch oder per Mail anmelden!</li>
                </ul>
            </li>
            <li><strong>Preise:</strong>
                <ul>
                    <li>Pro Person: <strong>15€</strong></li>
                    <li>Kinder bis 6 Jahre: <strong>5€</strong></li>
                </ul>
            </li>
            </ul>
        </div>
    )
}

export default Alpaka_Schnuppern